import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login.service';
import { Router } from '@angular/router';
import { PerfilService } from 'src/app/service/perfil.service';
import { TarjetasService } from 'src/app/service/tarjetas.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  session: any;
  nombre: string;
  suscription: any
  user: any;
  isActive: boolean = false;

  constructor(private login: LoginService, private route: Router, private perfil: PerfilService, private tarjetas: TarjetasService) {
    this.login.currentSession.subscribe(login => {
      this.session = login
    });
    this.perfil.currentUser.subscribe(user => this.user = user)
  }


  ngOnInit() {

    this.verificar();
    this.nombre = this.session.nombre

  }
  ngAfterViewInit() {
    this.nombre = this.user.nombre + " " + this.user.apePaterno;
  }

  ngOnchange() {

  }


  setMenu() {
    if (this.isActive) {
      this.isActive = false;
    } else {
      this.isActive = true;
    }
  }

  verificar() {

    if (!localStorage.hasOwnProperty('sesionPocae')) {
      localStorage.clear()
      this.route.navigate(['/'])
    }
  }

  closeSession() {
    localStorage.clear()
    this.tarjetas.addCards([]);
    this.route.navigate(['/'])
  }

}
